module.exports = __webpack_public_path__ + "static/media/photonlogo_light_nomargin.8c628171.svg";